import { render, staticRenderFns } from "./CategoryCarouselApp.vue?vue&type=template&id=8c89a258"
import script from "./CategoryCarouselApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryCarouselApp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CategoryCarouselApp.vue?vue&type=style&index=0&id=8c89a258&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports